import { render, staticRenderFns } from "./ReportRuleDrawer.vue?vue&type=template&id=145ae1e8&"
import script from "./ReportRuleDrawer.vue?vue&type=script&lang=js&"
export * from "./ReportRuleDrawer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports